import { get,post,getImage,postBlob,postMultipart } from "@/network/http";
//首页获取最火资源的接口
export const getFireMenu = (params) => get("/xyfiremenuv/xyFireMenuV/list",params);
//首页获取资源分类的接口
export const getBlockMenu = (params) => get("/xydicblockt/xyDicBlockT/menuList",params);

//--------------基础begin-----------------------
//部门begin
//---获取部门树
export const getDeptTreer = (params) => get("/security/baseDept/queryDeptTree",params);
//---部门查询
export const deptGet = (key,params) => get("/security/baseDept/getDept/"+key,params);
//---部门新增
export const deptAdd = (params) => post("/security/baseDept/addDept",params);
//---部门修改
export const deptEdit = (key,params) => post("/security/baseDept/updateDept/"+key,params);
//---部门删除
export const deptDelete = (key,params) => post("/security/baseDept/deleteDept/"+key,params);
//---获取角色和用户的左侧部门树
export const getLeftDeptTreer = (params) => get("/security/baseDept/leftDeptTree",params);
//部门end

//菜单begin
//---获取菜单树
export const getMenuTreer = (params) => get("/security/baseMenu/menuTree",params);
//---菜单查询
export const menuGet = (key,params) => get("/security/baseMenu/getMenu/"+key,params);
//---菜单新增
export const menuAdd = (params) => post("/security/baseMenu/addMenu",params);
//---菜单修改
export const menuEdit = (key,params) => post("/security/baseMenu/updateMenu/"+key,params);
//---菜单删除
export const menuDelete = (key,params) => post("/security/baseMenu/deleteMenu/"+key,params);
//---菜单删除
export const getLeftMenuTree = (params) => get("/security/baseMenu/getLeftMenuTree/",params);

//---菜单end

 
//角色begin
//---角色批量查询
export const getRoleList = (params) => get("/security/baseRole/queryRoles",params);
//---角色单条查询
export const getRoleSingle = (key,params) => get("/security/baseRole/getRole/"+key,params);
//---角色新增
export const roleAdd = (params) => post("/security/baseRole/addRole",params);
//---角色修改
export const roleEdit = (key,params) => post("/security/baseRole/updateRole/"+key,params);
//---角色删除
export const roleDelete = (key,params) => post("/security/baseRole/deleteRole/"+key,params); 
//---配置角色对应菜单
export const roleConfigMenu = (key,params) => post("/security/baseRole/configRoleMenu/"+key,params); 
//---角色end

//用户begin
//---用户批量查询
export const getUserList = (params) => get("/security/baseUser/queryUsers",params);
//---用户单条查询
export const getUserSingle = (key,params) => get("/security/baseUser/getUser/"+key,params);
//---用户新增
export const userAdd = (params) => post("/security/baseUser/addUser",params);
//---用户修改
export const userEdit = (key,params) => post("/security/baseUser/updateUser/"+key,params);
//---用户注销
export const updateUserStatus = (key,params) => post("/security/baseUser/updateUserStatus/"+key,params);
//---用户删除
export const userDelete = (key,params) => post("/security/baseUser/deleteUser/"+key,params); 
//---用户密码更新
export const updateUserPwd = (key,params) => post("/security/baseUser/updateUserPwd/"+key,params); 
//---用户密码初始化
export const useResetPwd = (key,params) => post("/security/baseUser/resetUserPwd/"+key,params); 
//---用户分配角色（可以是多个角色）
export const configUserRoles = (key,params) => post("/security/baseUser/configUserRoles/"+key,params); 
//查询用户名是否已经存在
export const userSameUser = (params) => get("/security/baseUser/selectSameUser",params); 
//查看用户已经拥有的角色
 export const selectBaseRoleByUserId = (params) => get("/security/baseUser/selectBaseRoleByUserId",params); 
//---用户end

//码表begin
//码表批量查询
export const getDictList = (params) => get("/security/baseDict/queryDicts",params);
//码表单条查询
export const getDictSingle = (key,params) => get("/security/baseDict/getDict/"+key,params);
//码表新增
export const dictAdd = (params) => post("/security/baseDict/addDict",params);
//码表修改
export const dictEdit = (key,params) => post("/security/baseDict/updateDict/"+key,params);
//码表删除
export const dictDel = (key,params) => post("/security/baseDict/deleteDict/"+key,params);
//码表更新缓存
export const updateDictCache = (key,params) => post("/security/cache/updateDictCache/",params);
//码表end

//路径begin
//路径批量查询
export const getLocationList = (params) => get("/security/baseLocation/queryLocations",params);
//路径单条查询
export const getLocationSingle = (key,params) => get("/security/baseLocation/getLocation/"+key,params);
//路径新增
export const locationAdd = (params) => post("/security/baseLocation/addLocation",params);
//路径修改
export const locationEdit = (key,params) => post("/security/baseLocation/updateLocation/"+key,params);
//路径删除
export const locationDel = (key,params) => post("/security/baseLocation/deleteLocation/"+key,params);

//路径删除
export const queryRoleCodesByLocation = (params) => get("/security/baseLocation/queryRoleCodesByLocation/",params);
 //获取角色code对应的路径信息
 export const getRoleCodesLocation = (key,params) => get("/security/baseLocation/getRoleLocation/"+key,params);
//路径end

//--------------基础end-----------------------

//首页获取资源信息列表的接口
export const getXyResourcesInfoV = (params) => get("/xyresourcesinfov/xyResourcesInfoV/list",params);

export const getXyResourcesInfoVOhter = (params) => get("/xyresourcesinfov/xyResourcesInfoVOther/list",params);

 

//---------------用户注册---------------------
//用户注册获取省份、地州的接口
export const getXyCityCode = (params) => get("/xydicbasecityt/xyDicBaseCityT/list",params);
//查询用户名是否已经存在
export const getSameUser = (params) => get("/xyuserinfot/xyUserInfoT/selectSameUser",params);
//用户注册提交
export const postNormalUserRegiser = (params) => post("/xyuserinfot/xyUserInfoT/add",params);

//查看用户的信息
export const getCurentInfo = (params) => get("/xyuserinfot/xyUserInfoT/get",params);

//更新用户基本信息 
export const updateMyUserInfo = (params) => post("/xyuserinfot/xyUserInfoT/update",params);

//批量查看用户信息
export const getUserInfoList = (params) => get("/xyuserinfot/xyUserInfoT/list",params);

//批量查看用户信息-不带用户头像照片
export const getUserInfoListOther = (params) => get("/xyuserinfot/xyUserInfoT/userlist",params);

//用户密码重置
export const resetUserPwd = (params) => post("/xyuserinfot/xyUserInfoT/resetUserPwd",params);

//申请成为开发者
export const normalToDeveloper = (params) => post("/xyuserinfot/xyUserInfoT/normalToDeveloper",params);

//申请成为开发者申请未通过
export const normalDisToDeveloper = (params) => post("/xyuserinfot/xyUserInfoT/normalDisToDeveloper",params);

//申请成为版主
export const developerToBlocker = (params) => post("/xyuserinfot/xyUserInfoT/developerToBlocker",params);

//申请成为版主申请未通过
export const developerDisToBlocker = (params) => post("/xyuserinfot/xyUserInfoT/developerDisToBlocker",params);

//用户信息查看
// export const getUserInfo = (params) => get("/xyuserinfot/xyUserInfoT/add",params);
//获取验证图片
export const getValidImage = (params) => getImage("/security/validcode/image",params);
//获取后端的session
export const getSession = (params) => get("/security/validcode/session",params);
//上传头像
export const uploadImage = (params) => postMultipart("/com/imageUpload",params);
//用户登录
export const login = (params) => post("/login",params);

//用户登录
export const logout = (params) => post("/logout",params);


//资源发布
export const resourceDisplay = (params) => postMultipart("/xyresourcesinfot/xyResourcesInfoT/add",params);
//资源查看
export const getResourceInfo = (params) => get("/xyresourcesinfot/xyResourcesInfoT/get",params);

//资源状态修改
export const resourceUpdate = (params) => post("/xyresourcesinfot/xyResourcesInfoT/update",params); 

//资源类型查找
export const getBlock = (params) => get("/xydicblockt/xyDicBlockT/list",params);
 
//资源下载
export const resourceDownload = (params) => postBlob("/xyresourcesinfot/xyResourcesInfoT/download",params);


//资源下载记录添加
// export const resourceDownloadAdd = (params) => post("/xydownloadrecordt/xyDownloadRecordT/add",params);
//资源下载记录查看
// export const resourceDownloadList = (params) => get("/xydownloadrecordt/xyDownloadRecordT/list",params);

//资源购买记录添加
export const resourceBuyRecordAdd = (params) => post("/xyresourcesbuyrecordt/xyResourcesBuyRecordT/add",params);
//资源购买记录查看
export const resourceBuyRecordList = (params) => get("/xyresourcesbuyrecordt/xyResourcesBuyRecordT/list",params);

//资源购买记录添加
export const resourceBuyRecordIf = (params) => post("/xyresourcesbuyrecordt/xyResourcesBuyRecordT/ifBuy",params);

//资源评论记录添加
export const resourceActiveAdd = (params) => post("/xyresourcesactivet/xyResourcesActiveT/add",params);

//资源评论记录查看
export const resourceActiveAList = (params) => get("/xyresourcesactivet/xyResourcesActiveT/list",params);


//签到获得积分
export const pointSignAdd = (params) => post("/xypointchangerecordt/xyPointChangeRecordT/signAdd",params);  
 
//购买积分
export const pointSaleAdd = (params) => post("/xypointsaledt/xyPointSaledT/add",params); 
 
//积分变动记录查询-多条
export const pointChangeList = (params) => get("/xypointchangerecordt/xyPointChangeRecordT/list",params);

//积分变动记录查询-单条
export const pointChangeGet = (params) => get("/xypointchangerecordt/xyPointChangeRecordT/get",params);

//积分变动记录新增
export const pointChangeAdd = (params) => post("/xypointchangerecordt/xyPointChangeRecordT/add",params);

//积分变动字典表查询
export const pointChangeTypeList = (params) => get("/xydicpointchangetypet/xyDicPointChangeTypeT/list",params);

//积分出售
export const pointWaitsaletAdd = (params) => post("/xypointwaitsalet/xyPointWaitSaleT/add",params);

//积分待售查询
export const pointwaitsalet = (params) => get("/xypointwaitsalet/xyPointWaitSaleT/list",params);


//通知信息类型
export const messageTypeList = (params) => get("/xydicnoticetypet/xyDicNoticeTypeT/list",params);

//用户通知信息添加
export const messageAdd = (params) => post("/xyusernoticet/xyUserNoticeT/add",params);

//用户通知信息批量查看
export const messageCount = (params) => get("/xyusernoticet/xyUserNoticeT/count",params); 

//用户通知信息批量查看
export const messagelist = (params) => get("/xyusernoticet/xyUserNoticeT/list",params); 

//用户通知信息批量查看从视图出数据
export const messageViewlist = (params) => get("/xyusernoticev/xyUserNoticeV/list",params); 

//用户通知信息单条查看
export const messageGet = (params) => get("/xyusernoticet/xyUserNoticeT/get",params); 

//用户通知信息删除
export const messageDelete = (params) => post("/xyusernoticet/xyUserNoticeT/delete",params); 

//用户通知信息变为已查看
export const messageSee = (params) => post("/xyusernoticet/xyUserNoticeT/see",params); 
 
//获取普通用户的菜单
export const getCommonMenu = (params) => get("/security/baseMenu/myMenuTree",params);

//获取版主和管理员的菜单
export const getAdminMenu = (params) => get("/security/baseUser/menuTree",params);


//我的基本信息


//获取用户积分变动信息
//export const getPointChangeRecordt = (params) => get("/xypointchangerecordt/xyPointChangeRecordT/list",params);
//用户待售积分排名查询
export const getPointWaitSalet = (params) => get("/xypointwaitsalet/xyPointWaitSaleT/list",params);
//用户积分已售信息列表
export const getPointSaledt = (params) => get("/xypointsaledt/xyPointSaledT/list",params);

//用户积分已售信息列表
export const getPointSaledV = (params) => get("/xypointsaledv/xyPointSaledV/list",params);

//用户积分已售信息单条
export const getSinglePointSaled = (params) => get("/xypointsaledt/xyPointSaledT/get",params);
 

//用户积分已售信息列表
export const updatePointSaledt = (params) => post("/xypointsaledt/xyPointSaledT/update",params);

//用户修改密码
export const editUserPassWord = (params) => post("/xyuserinfot/xyUserInfoT/editPass",params);






//投诉内容添加
export const complaintAdd = (params) => postMultipart("/xycomplaintt/xyComplaintT/add",params);

//投诉列表
export const complaintlist = (params) => get("/xycomplaintv/xyComplaintV/list",params);

//投诉查看
export const complaintGet = (params) => get("/xycomplaintt/xyComplaintT/get",params);

//投诉类型列表
export const complaintTypelist = (params) => get("/xydiccomplainttypet/xyDicComplaintTypeT/list",params);

//投诉回帖
export const complaintActiveAdd = (params) => post("/xycomplaintactivet/xyComplaintActiveT/add",params);

//投诉回帖的一级列表
export const complaintActiveList = (params) => get("/xycomplaintactivet/xyComplaintActiveT/list",params);

//投诉状态变更为已处理
export const complaintActiveUpdate = (params) => post("/xycomplaintt/xyComplaintT/update",params);

//全体通知查看
export const allNotictGet = (params) => get("/xyallnoticet/xyAllNoticeT/get",params);
//全体通知编辑
export const allNotictUpdate = (params) => post("/xyallnoticet/xyAllNoticeT/update",params);

//资源推荐
export const resourcesUp = (params) => post("/xyresourcesupt/xyResourcesUpT/add",params);
//获取当天浏览-登录-上传数量
export const getDayInfo = (params) => get("/xydayaccesst/xyDayAccessT/getDayInfo",params);

//百度网盘查看
export const getBaiduNetDisk = (params) => get("/xybaidunetdiskt/xyBaiDuNetDiskT/list",params);

//获取认证 调用授权页面
export const baiDuGetCode = (params) => get("/baidu/getCode",params);
//token 刷新
export const getTokenRefresh = (params) => get("/baidu/getTokenRefresh",params);